import cx from '../../../../utils/cx';

import styles from './CollageStrips.module.scss';

const CollageStrips = ({ images, rowsCount, className, isAlternating }) => {
  return (
    <div className={cx(styles.strips, className)}>
      {Array.from({ length: rowsCount }, (_, index) => (
        <div key={index} className={styles.row}>
          <div
            className={cx(styles.track, {
              [styles.trackLeft]: isAlternating && index % 2 === 0,
            })}
          >
            <img src={images[index % images.length]} alt="" />
            <img src={images[index % images.length]} alt="" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CollageStrips;
